import React from "react";
import { Typography } from "@mui/material";
import styled from "styled-components";
import { ViewDiff, isDiffEmptyForVariant } from "../ViewDiff";

const displayNames = {
	title: 'Title',
	descriptionShort: 'Short Description',
	ballotText: 'Appears on ballot as',
	actNumbers: 'Act numbers',
	whatItMeans: 'What it means',
	supportersSay: 'What a yes vote means',
	opponentsSay: 'What a no vote means',
};

const MEASURE_SECTIONS = [
	'title',
	'descriptionShort',
	'ballotText',
	'actNumbers',
	'whatItMeans',
	'supportersSay',
	'opponentsSay',
];

/** One measure field: before on the left, after with green/red highlighting on the right. Empty side = no card. */
function DiffItemRow({ label, diff }) {
	const segmentDiff = Array.isArray(diff) ? diff : [];
	const beforeEmpty = isDiffEmptyForVariant(segmentDiff, 'before');
	const afterEmpty = isDiffEmptyForVariant(segmentDiff, 'after');
	return (
		<ItemBlock>
			<ItemSectionLabel>{label}</ItemSectionLabel>
			<ItemRow>
				{beforeEmpty ? <EmptyCell /> : (
					<ItemCell>
						<ViewDiff diff={segmentDiff} variant="before" />
					</ItemCell>
				)}
				{afterEmpty ? <EmptyCell /> : (
					<ItemCell className="after">
						<ViewDiff diff={segmentDiff} variant="after" />
					</ItemCell>
				)}
			</ItemRow>
		</ItemBlock>
	);
}

const ViewMeasureDiff = ({ diff }) => (
	<Wrapper>
		{MEASURE_SECTIONS.map((key) => (
			<DiffItemRow
				key={key}
				label={displayNames[key]}
				diff={diff?.[key]}
			/>
		))}
	</Wrapper>
);

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: stretch;
	width: 100%;
	gap: 24px;
`;

const ItemBlock = styled.div`
	margin-bottom: 16px;
`;

const ItemSectionLabel = styled.div`
	font-size: 0.875rem;
	font-weight: 600;
	color: #333;
	margin-bottom: 6px;
`;

const ItemRow = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 16px;
	align-items: start;
`;

const ItemCell = styled.div`
	min-width: 0;
	padding: 12px;
	border: 1px solid #eee;
	border-radius: 6px;
	background-color: #fafafa;
	&.after { background-color: #fff; }
`;

const EmptyCell = styled.div`
	min-width: 0;
`;

export { ViewMeasureDiff };